// Assign the status name to their bitwise equivalent
const PendingSpamCheck = 64
const SpamDetected = 128

export default {
  methods: {
    checkProjectStatus: function (status) {
      switch (status) {
        case PendingSpamCheck:
          return 'pendingSpamCheck'
        case SpamDetected:
          return 'spamDetected'
        default:
          break
      }
    }
  }
}
